import { isTestingEmail } from "../constants";

const DEFAULT_KOUNT_CLIENT_ID = "654310318262645";
const DEFAULT_KOUNT_ENVIRONMENT = "PROD";

function getRandomHex(length) {
  const bytesNeeded = Math.ceil(length / 2);
  const bytes = new Uint8Array(bytesNeeded);
  window.crypto.getRandomValues(bytes);
  return Array.from(bytes, (byte) => byte.toString(16).padStart(2, "0"))
    .join("")
    .slice(0, length);
}

export function generateKountSessionId() {
  if (window.crypto?.randomUUID) {
    return window.crypto.randomUUID().replace(/-/g, "").substring(0, 32);
  }

  return getRandomHex(32);
}

function normalizeEnvironment(value) {
  const normalized = `${value || DEFAULT_KOUNT_ENVIRONMENT}`.trim().toUpperCase();
  return normalized === "PROD" ? "PROD" : "TEST";
}

function normalizeSpaFlag(value) {
  return `${value || "false"}`.trim().toLowerCase() === "true";
}

function extractSdkPayload(rawResult) {
  if (!rawResult || typeof rawResult !== "object") {
    return {};
  }

  return {
    kountDeviceData: rawResult.deviceData || rawResult.device_data || null,
    kountDecisionToken:
      rawResult.decisionToken || rawResult.decision_token || null,
  };
}

export async function collectKountData(email) {
  const sessionId = generateKountSessionId();
  const resolvedEnvironment = isTestingEmail(email)
    ? "TEST"
    : normalizeEnvironment(process.env.REACT_APP_KOUNT_ENVIRONMENT);
  const kountConfig = {
    clientID:
      process.env.REACT_APP_KOUNT_CLIENT_ID || DEFAULT_KOUNT_CLIENT_ID,
    environment: resolvedEnvironment,
    isSinglePageApp: normalizeSpaFlag(process.env.REACT_APP_KOUNT_IS_SPA),
  };

  const basePayload = {
    kountSessionId: sessionId,
    kountClientId: kountConfig.clientID,
    kountEnvironment: kountConfig.environment,
    kountIsSinglePageApp: kountConfig.isSinglePageApp,
    kountCollectedAt: new Date().toISOString(),
  };

  try {
    const module = await import("@kount/kount-web-client-sdk");
    const kountSDK = module.default || module;
    const rawResult = await Promise.resolve(kountSDK(kountConfig, sessionId));

    return {
      ...basePayload,
      kountSdkInvoked: true,
      ...extractSdkPayload(rawResult),
    };
  } catch (error) {
    return {
      ...basePayload,
      kountSdkInvoked: false,
      kountCollectionError: error?.message || "Unknown KOUNT error",
    };
  }
}
